/**
 * Wire Shopify Files Full Demo MP3s to product pages and catalogue cards.
 * Bundles (except the-bundle-3) play demos from packs listed in the bundle description.
 */
(function () {
  'use strict';

  var MANIFEST_URL =
    typeof window.UG_PRODUCT_DEMOS_MANIFEST_URL === 'string'
      ? window.UG_PRODUCT_DEMOS_MANIFEST_URL
      : '';
  var BUNDLE_CONTENTS_URL =
    typeof window.UG_BUNDLE_CONTENTS_MANIFEST_URL === 'string'
      ? window.UG_BUNDLE_CONTENTS_MANIFEST_URL
      : '';

  /**
   * Bundle 3 has its own bespoke PDP player (ug-bundle-product.js), so this
   * script must never wire the Bundle 3 *product page*. Its catalogue *cards*
   * (collection grids, related products) are still wired here so they preview a
   * pack demo and add the bundle, like every other bundle card.
   */
  var SKIP_PRODUCT_PAGE_HANDLES = {
    'the-bundle-3': true
  };

  function encodeAudioUrl(url) {
    if (!url) return '';
    return String(url).replace(/#/g, '%23');
  }

  function loadJson(url, cacheKey) {
    if (!url) return Promise.resolve(null);
    window.__ugManifestCache = window.__ugManifestCache || {};
    if (window.__ugManifestCache[cacheKey]) {
      return Promise.resolve(window.__ugManifestCache[cacheKey]);
    }
    return fetch(url, { credentials: 'same-origin' })
      .then(function (r) {
        if (!r.ok) throw new Error('manifest');
        return r.json();
      })
      .then(function (json) {
        window.__ugManifestCache[cacheKey] = json;
        return json;
      });
  }

  function demosForHandle(manifest, handle) {
    if (!manifest || !handle) return [];
    var list = manifest[handle];
    return Array.isArray(list) ? list : [];
  }

  function handleFromProductUrl(url) {
    var match = String(url || '').match(/\/products\/([^/?#]+)/);
    return match ? match[1] : '';
  }

  function fetchVariantIdForHandle(handle) {
    if (!handle) return Promise.resolve('');
    return fetch('/products/' + encodeURIComponent(handle) + '.js', { credentials: 'same-origin' })
      .then(function (res) {
        return res.ok ? res.json() : null;
      })
      .then(function (product) {
        if (!product || !product.variants || !product.variants.length) return '';
        var variant = product.variants.find(function (v) {
          return v.available;
        });
        if (!variant) variant = product.variants[0];
        return variant && variant.id ? String(variant.id) : '';
      })
      .catch(function () {
        return '';
      });
  }

  function applyTrackToButton(btn, demo, meta) {
    if (!btn || !demo || !demo.url) return;
    btn.setAttribute('data-ug-audio-src', encodeAudioUrl(demo.url));
    if (meta.title) btn.setAttribute('data-ug-audio-title', meta.title);
    if (meta.image) btn.setAttribute('data-ug-audio-image', meta.image);
    if (meta.productUrl) btn.setAttribute('data-ug-audio-product-url', meta.productUrl);
    if (meta.variantId) btn.setAttribute('data-ug-audio-variant-id', meta.variantId);
  }

  function attachVariantId(btn, productUrl) {
    var handle = handleFromProductUrl(productUrl);
    if (!handle) return;
    fetchVariantIdForHandle(handle).then(function (variantId) {
      if (variantId && btn.isConnected) {
        btn.setAttribute('data-ug-audio-variant-id', variantId);
      }
    });
  }

  function appendHiddenTrack(host, demo, meta, order) {
    var btn = document.createElement('button');
    btn.type = 'button';
    btn.className = 'ug-audio-play-trigger ug-product-demo-track';
    btn.hidden = true;
    btn.setAttribute('data-ug-demo-index', String(order));
    applyTrackToButton(btn, demo, meta);
    host.appendChild(btn);
    return btn;
  }

  function trackTitle(childTitle, demo) {
    if (!childTitle) return demo.label || 'Preview';
    if (demo.index > 1) return childTitle + ' — Demo ' + demo.index;
    return childTitle;
  }

  function flattenBundleTracks(manifest, bundleEntry) {
    var tracks = [];
    if (!bundleEntry || !bundleEntry.handles) return tracks;

    bundleEntry.handles.forEach(function (childHandle) {
      var demos = demosForHandle(manifest, childHandle);
      var childTitle =
        (bundleEntry.titles && bundleEntry.titles[childHandle]) || childHandle;
      var productUrl = '/products/' + childHandle;
      demos.forEach(function (demo) {
        tracks.push({
          demo: demo,
          meta: {
            title: trackTitle(childTitle, demo),
            productUrl: productUrl
          }
        });
      });
    });
    return tracks;
  }

  function wireTracksToPage(ctx, tracks, defaults) {
    if (!tracks.length) return;

    var host = ctx.querySelector('[data-ug-product-demos]');
    if (!host) return;

    var image = defaults.image || '';
    var bundleUrl = defaults.productUrl || window.location.pathname;

    var hero = ctx.querySelector('.ug-audio-play-trigger--hero');
    if (hero) {
      var first = tracks[0];
      applyTrackToButton(hero, first.demo, {
        title: first.meta.title,
        image: image,
        productUrl: first.meta.productUrl || bundleUrl
      });
      attachVariantId(hero, first.meta.productUrl || bundleUrl);
      hero.removeAttribute('data-ug-audio-scope');
    }

    host.textContent = '';
    for (var i = 1; i < tracks.length; i++) {
      var trackBtn = appendHiddenTrack(
        host,
        tracks[i].demo,
        {
          title: tracks[i].meta.title,
          image: image,
          productUrl: tracks[i].meta.productUrl || bundleUrl
        },
        i + 1
      );
      attachVariantId(trackBtn, tracks[i].meta.productUrl || bundleUrl);
    }
  }

  function wireSingleProductPage(manifest, ctx, handle) {
    var demos = demosForHandle(manifest, handle);
    if (!demos.length) return;

    var productTitle =
      ctx.querySelector('.page-title')?.textContent?.trim() ||
      demos[0].label?.replace(/\s*—.*/, '') ||
      '';
    var productUrl = window.location.pathname;
    var image =
      ctx.querySelector('.ug-audio-play-trigger--hero')?.getAttribute('data-ug-audio-image') ||
      '';

    var tracks = demos.map(function (demo) {
      return {
        demo: demo,
        meta: {
          title: trackTitle(productTitle, demo),
          productUrl: productUrl
        }
      };
    });

    wireTracksToPage(ctx, tracks, { image: image, productUrl: productUrl });
  }

  function wireBundleProductPage(manifest, bundleContents, ctx, handle) {
    var entry = bundleContents && bundleContents[handle];
    if (!entry || !entry.handles || !entry.handles.length) return;

    var image =
      ctx.querySelector('.ug-audio-play-trigger--hero')?.getAttribute('data-ug-audio-image') ||
      '';
    var bundleUrl = window.location.pathname;
    var tracks = flattenBundleTracks(manifest, entry);
    // Demos previewed from a bundle PDP represent the *bundle*, not the individual
    // packs: keep each pack's title (so the listener can tell which demo is playing)
    // but point the artwork and Add-to-Cart at the bundle product itself.
    tracks.forEach(function (t) {
      t.meta.productUrl = bundleUrl;
    });
    wireTracksToPage(ctx, tracks, {
      image: image,
      productUrl: bundleUrl
    });
  }

  function wireProductPage(manifest, bundleContents) {
    var ctx = document.querySelector('[data-ug-audio-page-context][data-product-handle]');
    if (!ctx) return;

    var handle = ctx.getAttribute('data-product-handle');
    if (!handle || SKIP_PRODUCT_PAGE_HANDLES[handle]) return;

    var bundleEntry = bundleContents && bundleContents[handle];
    var isBundle =
      ctx.classList.contains('und-bundle-product') ||
      !!(bundleEntry && bundleEntry.handles && bundleEntry.handles.length);

    if (isBundle) {
      wireBundleProductPage(manifest, bundleContents, ctx, handle);
      return;
    }

    wireSingleProductPage(manifest, ctx, handle);
  }

  function wireCardButtons(manifest, bundleContents) {
    document.querySelectorAll('[data-ug-product-demo-handle]').forEach(function (btn) {
      var handle = btn.getAttribute('data-ug-product-demo-handle');
      if (!handle) return;

      var demos = demosForHandle(manifest, handle);
      if (!demos.length && bundleContents && bundleContents[handle]) {
        var tracks = flattenBundleTracks(manifest, bundleContents[handle]);
        if (tracks.length) demos = [tracks[0].demo];
      }
      if (!demos.length) return;

      var title = btn.getAttribute('data-ug-audio-title') || '';
      var image = btn.getAttribute('data-ug-audio-image') || '';
      var productUrl = btn.getAttribute('data-ug-audio-product-url') || '#';

      if (bundleContents && bundleContents[handle] && bundleContents[handle].handles.length) {
        var firstTrack = flattenBundleTracks(manifest, bundleContents[handle])[0];
        if (firstTrack) {
          // A bundle card previews a child pack's demo audio (with the pack's
          // title) but represents the *bundle*: keep the card's own product URL +
          // variant so Add-to-Cart adds the bundle, not the individual pack.
          title = firstTrack.meta.title;
          demos = [firstTrack.demo];
        }
      }

      applyTrackToButton(btn, demos[0], {
        title: title,
        image: image,
        productUrl: productUrl
      });
      if (!btn.getAttribute('data-ug-audio-variant-id')) {
        attachVariantId(btn, productUrl);
      }
    });
  }

  function boot() {
    var demosPromise = loadJson(MANIFEST_URL, 'demos:' + MANIFEST_URL);
    var bundlePromise = loadJson(BUNDLE_CONTENTS_URL, 'bundles:' + BUNDLE_CONTENTS_URL);

    Promise.all([demosPromise, bundlePromise.catch(function () { return null; })])
      .then(function (results) {
        var manifest = results[0];
        var bundleContents = results[1];
        if (!manifest) return;
        wireProductPage(manifest, bundleContents);
        wireCardButtons(manifest, bundleContents);
      })
      .catch(function () {
        /* metafields / legacy liquid src remain */
      });
  }

  // Exposed so instant-navigation (Swup) can re-boot demos after a page swap.
  window.ugBootProductDemos = boot;

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
